import PropTypes from 'prop-types';
import Select, { components } from 'react-select';

import { isEmpty, isNull, isUndefined } from 'lodash';

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <img
      width={10}
      height={8}
      style={{ width: 12, height: 12 }}
      src="https://www.datocms-assets.com/10154/1657782844-arrowdownpurple.svg"
      alt=""
    />
  </components.DropdownIndicator>
);

const Input = (props) => {
  return (
    <components.Input {...props}>
      <label className="visually-hidden"></label>
    </components.Input>
  );
};

const getThemeColors = (color) => (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: '#DEDFE1',
    primary: color,
  },
});

const themeColorsNew = getThemeColors('#002334');

const SelectInput = ({
  id,
  name,
  onChange,
  onBlur,
  options,
  defaultValue,
  value,
  className,
  style,
  components,
  additionalStyles,
  onMenuOpen,
  onMenuClose,
  noLabel,
  selectInputId,
}) => {
  const noValue = value === 'undefined';

  const inputId = `select-${selectInputId}`;
  const additionalProps =
    !isEmpty(id) && !isNull(id) && !isUndefined(id) ? { id } : {};

  return (
    <>
      {noLabel && (
        <label
          htmlFor={inputId}
          style={{ opacity: 0, height: 0, display: 'inherit' }}
        >
          {inputId}
        </label>
      )}
      <Select
        {...additionalProps}
        inputId={inputId}
        className={className}
        style={style}
        aria-label={name}
        components={{
          ...components,
          DropdownIndicator,
          IndicatorSeparator: null,
          Input,
        }}
        defaultValue={options[defaultValue]}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        onMenuOpen={onMenuOpen}
        onMenuClose={onMenuClose}
        options={options}
        isSearchable={false}
        inputProps={{ readOnly: true }}
        styles={{
          menu: (provided) => ({ ...provided, zIndex: 999999 }),
          singleValue: (base) => ({
            ...base,
            fontSize: '14px',
            lineHeight: '14px',
            color: noValue ? '#DEDFE1' : '#002334',
          }),
          control: (base) => ({
            ...base,
            border: `1px solid ${noValue ? '#DEDFE1' : '#002334'}`,
            borderRadius: 0,
          }),
          ...additionalStyles,
        }}
        theme={themeColorsNew}
        value={noValue ? options['0'] : options[value]}
      />
    </>
  );
};

SelectInput.propTypes = {
  name: PropTypes.string,
  options: PropTypes.array,
  defaultValue: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  components: PropTypes.object,
  noLabel: PropTypes.bool,
  selectInputId: PropTypes.string,
};

SelectInput.defaultProps = {
  name: '',
  options: [],
  defaultValue: 0,
  value: '',
  onChange: () => {},
  onBlur: () => {},
  noLabel: true,
  selectInputId: '',
};

export default SelectInput;
